<div class="option-wrapper" (click)="selectItem(item)">
  <ng-container *ngTemplateOutlet="display? display: defaultDisplay; context:this"></ng-container>
</div>

<ng-template #defaultDisplay>
  <div class="option button">
    <div class="image-container"> <img [src]="item?.image" alt=""></div>
    <div class="information-container">
      <div class="title">
        <span class="name">{{item?.name}}</span>
        <span class="value"><i class="fa" [ngClass]="item?.icon"></i>{{item?.value}}</span>
      </div>
      <div class="info">
        <div class="description"><span>{{item?.description}}</span></div>
      </div>

    </div>
  </div>
</ng-template>
